import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "Page Not Found", description: "The page you're looking for doesn't exist.", path: "/404" });
  return (
    <section className="mx-auto flex min-h-[80vh] w-full max-w-7xl flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <p className="font-display text-[clamp(6rem,20vw,14rem)] font-bold leading-none text-outline" aria-hidden="true">
        404
      </p>
      <h1 className="mt-4 font-display text-2xl font-semibold text-paper-100">This page drifted into the void.</h1>
      <p className="mt-3 max-w-md text-sm text-paper-500">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-button"
        className="mt-8 rounded-full bg-white px-8 py-3.5 text-sm font-semibold text-black transition-transform duration-300 hover:scale-[1.04]"
      >
        Back to home
      </Link>
    </section>
  );
}
